import styled from '@emotion/styled'

type SectionBlockProps = {
	title: string
	subTitle?: string
	children: React.ReactNode
}

const SectionBlock = ({ title, subTitle, children }: SectionBlockProps) => {
	return (
		<Section>
			<div>
				<Header>
					<Title>{title}</Title>
					{subTitle && <SubTitle>{subTitle}</SubTitle>}
				</Header>
				<Content>{children}</Content>
			</div>
		</Section>
	)
}

const Section = styled.section`
	display: flex;
	justify-content: center;
	width: 100%;
	padding: 3rem 12.5rem 0.6rem;

	& > div {
		width: 103rem;
		background: #fff;
	}
`

const Header = styled.div`
	padding: 2rem 2.8rem;
`

const Title = styled.h2`
	font-size: 1.7rem;
	font-weight: 700;
	line-height: 2.4rem;
	color: #363644;
`

const SubTitle = styled.p`
	font-size: 1.3rem;
	font-weight: 400;
	line-height: 2.2rem;
	margin-top: 0.8rem;
	color: #787887;
`

const Content = styled.div`
	display: flex;
	flex-direction: column;
	border-top: 1px solid #e7e7ed;
	padding: 2rem 2.8rem;
`

export default SectionBlock
